import { Injectable } from '@angular/core';
declare var pubnubInitializer: any;
import PubNub from 'pubnub';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PubnubService {
    pubnub: any;

    constructor() { }

    initPubnub(secretKey: string) {
        this.pubnub = new PubNub({
            publishKey: environment.PUBNUB_KEYS.PUBLISH_KEY,
            subscribeKey: environment.PUBNUB_KEYS.SUBSCRIBE_KEY,
            uuid: secretKey,
        });
    }

    getPubNub(): any {
        return this.pubnub;
    }
}
